import { Flex, Image, ConnectionItem, Button } from "@wayflyer/flyui";
import { useState, type ReactNode } from "react";
import { useIntl } from "react-intl";
import type { ConnectorPropertiesSchema } from "../../data-sources/schemas";

import { COMMON_MESSAGES } from "../common-messages";

export const ConnectionsList = ({
  connectorProperties,
  connectForm,
}: {
  connectorProperties: ConnectorPropertiesSchema;
  connectForm: ReactNode;
}) => {
  const intl = useIntl();
  const [isFormVisible, setFormVisible] = useState(false);

  const connectedPlatformsList: string[] | null =
    connectorProperties && !!connectorProperties.connections.length
      ? connectorProperties.connections.map((connection) => {
          return connection.identifierName ?? connectorProperties.name;
        })
      : null;

  return (
    <Flex direction="column" width="100%" gap="4">
      {connectedPlatformsList ? (
        <>
          <ConnectionItem
            label={connectorProperties.name}
            logo={
              connectorProperties.connectionLogoSrc ? (
                <Image src={connectorProperties.connectionLogoSrc} alt="" />
              ) : undefined
            }
            badgeStatus="positive"
            badgeText={intl.formatMessage(COMMON_MESSAGES.connected)}
            subtitle={
              <ul>
                {connectedPlatformsList?.map((value, index) => (
                  <li key={value + index}>{value}</li>
                ))}
              </ul>
            }
          />

          {!isFormVisible && connectorProperties.multipleConnectionsAllowed && (
            <Flex>
              <Button variant="Secondary" size="small" onClick={() => setFormVisible(true)}>
                {intl.formatMessage(COMMON_MESSAGES.addAnother)}
              </Button>
            </Flex>
          )}

          {isFormVisible && (
            <Flex direction="column" padding={["4", "0"]} gap="2">
              {connectForm}
            </Flex>
          )}
        </>
      ) : (
        connectForm
      )}
    </Flex>
  );
};
